import ClienteListDados from '../../produto/spa/cliente/ClienteListDados';

export default ClienteListDados;
